export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13969.d966e84e.jpg";